<script lang="ts">
  import newUniqueId from 'locally-unique-id-generator';

  const id = newUniqueId();
</script>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 281 281" fill="none">
  <path
    d="M140.53 280.609C217.85 280.609 280.53 217.929 280.53 140.609C280.53 63.2888 217.85 0.608643 140.53 0.608643C63.2098 0.608643 0.529663 63.2888 0.529663 140.609C0.529663 217.929 63.2098 280.609 140.53 280.609Z"
    fill={`url(#${id})`}
  />
  <defs>
    <radialGradient
      {id}
      cx="0"
      cy="0"
      r="1"
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(140.53 140.609) scale(140)"
    >
      <stop offset="0.54" stop-color="white" />
      <stop offset="0.59" stop-color="white" stop-opacity="0.98" />
      <stop offset="0.65" stop-color="white" stop-opacity="0.93" />
      <stop offset="0.71" stop-color="white" stop-opacity="0.85" />
      <stop offset="0.77" stop-color="white" stop-opacity="0.73" />
      <stop offset="0.83" stop-color="white" stop-opacity="0.58" />
      <stop offset="0.89" stop-color="white" stop-opacity="0.39" />
      <stop offset="0.943875" stop-color="white" stop-opacity="0.17" />
      <stop offset="1" stop-color="white" stop-opacity="0" />
    </radialGradient>
  </defs>
</svg>
